export interface TUsersState {
  user: InfoUserType | null;
  users: TInfoClient[] | null;
  readonly error?: string | undefined;
  isAuth?: boolean | undefined;
  isAccess?: boolean | undefined;
}

export type InfoUserType = {
  fio: string;
  email: string;
  id2: string;
  typeUser: number;
  isAdmin: number;
  post: string;
  company: string;
  userSubs: string;
  phone: string;
  bday: string;
  isRegister: boolean;
};

export type TInfoClient = {
  fio: string;
  id2: string;
  email: string;
  phone: string;
  post: string;
  company: string;
};

export type InfoClientType = {
  fio: string;
  id2: string;
};

export interface TDataToCheck {
  event_id: number;
}

export interface TDataShowUsers {
  event_id: number;
  roomId: number;
}

export interface IUserProduct {
  accessType: string;
  baseProduct: number;
  codeValue: string;
  createDate: string;
  dateEnd: string;
  dateStart: string;
  id: string;
  isActive: boolean;
  parent_id: number;
  productVersion: number;
  simpleProduct: string;
  userId: number;
}

enum ActionTypes {
  SET_ERROR = 'SET_ERROR',
  SET_IS_AUTH = 'SET_IS_AUTH',

  CHECK_USER_R = 'CHECK_USER_R',
  CHECK_USER_S = 'CHECK_USER_S',
  CHECK_USER_E = 'CHECK_USER_E',
  SHOW_USERS_R = 'SHOW_USERS_R',
  SHOW_USERS_S = 'SHOW_USERS_S',
}

export default ActionTypes;
